const configInBrowserStub: any = {
  'blockchain.chain_id': '80001',
  'blockchain.chain_name': 'mumbai',
  'blockchain.wallet.default.private_key':
    '0xec226ef7d02c0ed6fa9a331c4a3e364571d07039f79f8927dc3d624df27ccc8e',
  'node.admin_address': '0x50e2dac5e78B5905CB09495547452cEE64426db2',
  'node.enable_actions_allowlist': false,
  'node.enable_ecdsa_dkg': true,
  'node.enable_epoch_transitions': false,
  'node.enable_rate_limiting': false,
  'node.gpg_pubkey':
    '-----BEGIN PGP PUBLIC KEY BLOCK-----\n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\n=eI3j\n-----END PGP PUBLIC KEY BLOCK-----\n',
  'node.rpc_url':
    'https://polygon-mumbai.g.alchemy.com/v2/onvoLvV97DDoLkAmdi0Cj7sxvfglKqDh',
  'node.staker_address': '0x2fDdBfFC741920a2ff38ee3f38010De74909B992',
};

const fullResObj = {
  success: 'true',
  config: {
    'node.enable_ecdsa_dkg': 'true',
    'node.enable_ecdsa_dkg_batch_sending': 'true',
    'node.enable_actions_allowlist': 'false',
    'blockchain.wallet.default.private_key':
      '18fa8a585524c3c3418c35cadb489c5d729f9b43890903bc1d58f3f4e910ce91',
    'node.gpg_pubkey':
      '-----BEGIN PGP PUBLIC KEY BLOCK-----\n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\n=eI3j\n-----END PGP PUBLIC KEY BLOCK-----\n',
    'node.enable_rate_limiting': 'false',
    'node.enable_epoch_transitions': 'true',
    'blockchain.chain_id': '80001',
    'node.staker_address': '0x14A0Ffe724c5ECCBEe42ef6a95751C5B5552B413',
    'blockchain.chain_name': 'mumbai',
    'node.enable_ecdsa_batch_sending': 'false',
    'node.admin_address': '0x50e2dac5e78B5905CB09495547452cEE64426db2',
    'node.ecdsa_round_timeout': '20000',
    'node.ecdsa_batch_send_interval': '250',
    'node.rpc_url': '',
  },
  rpcConfig: {
    avalanche: [
      {
        url: 'https://api.avax.network/ext/bc/C/rpc',
      },
    ],
    fuji: [
      {
        url: 'https://api.avax-test.network/ext/bc/C/rpc',
      },
    ],
    alfajores: [
      {
        url: 'https://alfajores-forno.celo-testnet.org',
      },
    ],
    eluvio: [
      {
        url: 'https://host-76-74-28-226.contentfabric.io/eth',
      },
    ],
    xdc: [
      {
        url: 'https://rpc.xinfin.network',
      },
    ],
    bsc: [
      {
        url: 'https://bsc-dataseed.binance.org',
      },
    ],
    harmony: [
      {
        url: 'https://rpc.s0.t.hmny.io',
      },
    ],
    arbitrum: [
      {
        url: 'https://arb1.arbitrum.io/rpc',
      },
    ],
    rinkeby: [
      {
        url: 'https://rinkeby.infura.io/v3/96dffb3d8c084dec952c61bd6230af34',
      },
    ],
    celo: [
      {
        url: 'https://forno.celo.org',
      },
    ],
    polygon: [
      {
        url: 'https://polygon-rpc.com',
      },
    ],
    fantom: [
      {
        url: 'https://rpcapi.fantom.network',
      },
    ],
    evmos: [
      {
        url: 'https://eth.bd.evmos.org:8545',
      },
    ],
    evmosTestnet: [
      {
        url: 'https://eth.bd.evmos.dev:8545',
      },
    ],
    ropsten: [
      {
        url: 'https://ropsten.infura.io/v3/96dffb3d8c084dec952c61bd6230af34',
      },
    ],
    xdai: [
      {
        url: 'https://rpc.gnosischain.com',
      },
    ],
    goerli: [
      {
        url: 'https://goerli.infura.io/v3/96dffb3d8c084dec952c61bd6230af34',
      },
    ],
    kovan: [
      {
        url: 'https://kovan.infura.io/v3/96dffb3d8c084dec952c61bd6230af34',
      },
    ],
    mumbai: [
      {
        url: 'https://polygon-mumbai.g.alchemy.com/v2/onvoLvV97DDoLkAmdi0Cj7sxvfglKqDh',
      },
    ],
    ethereum: [
      {
        url: 'https://mainnet.infura.io/v3/96dffb3d8c084dec952c61bd6230af34',
      },
      {
        url: 'https://eth-mainnet.g.alchemy.com/v2/csvV3bBtx2v8uX3APunm8z-HD3Twqa8Q',
        headers: {
          BLAH: 'BLAHBLAHBLAH',
        },
        apikey: 'ASD',
      },
    ],
    optimism: [
      {
        url: 'https://optimism-mainnet.infura.io/v3/96dffb3d8c084dec952c61bd6230af34',
      },
    ],
    aurora: [
      {
        url: 'https://mainnet.aurora.dev',
      },
    ],
    cronos: [
      {
        url: 'https://evm-cronos.org',
      },
    ],
  },
};

export { configInBrowserStub, fullResObj };
